<template>
    <div class="text-center">
        <v-dialog
        v-model="testLiveRateDialog"
        scrollable
         width="800">
            <v-card>
                <v-card-title>
                    <span>Test Live Rate</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <!-- PAYLOAD -->
                        <v-row>
                            <v-col class=text-left>
                                <p class="modal-label">Update or paste the JSON below. You also have the option to include multiple payloads using the following format: [{PAYLOAD_1}, {PAYLOAD_2}].</p>
                                <v-textarea
                                    class="payload-data w-100"
                                    solo
                                    auto-grow
                                    label="payload"
                                    clearable
                                    :disabled="testRunning"
                                    @input="parsePayload"
                                    @blur="parsePayload"
                                    v-model="formattedPayloads">
                                </v-textarea>
                                <small v-if="inValidJson" class="text-danger">Invalid Json</small>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="pb-3">
                    <v-spacer></v-spacer>
                    <v-btn v-if="testSuccessful" small @click="openLogsInNewTab" title="Open logs in new tab">
                        <span>View Results</span>
                        <v-icon class="ml-2" size="16">mdi-open-in-new</v-icon>
                    </v-btn>
                    <v-btn small @click="$emit('testLiveRateModalClose')">Close</v-btn>
                    <v-btn small color="success" @click="runTest" :disabled="inValidJson || testRunning">
                        <span v-if="testRunning">
                            <v-progress-circular
                            indeterminate
                                size="12"
                                width="2"
                            color="green darken-3">
                            </v-progress-circular>
                            Running Test
                        </span>
                        <span v-else>Run Test</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>
.v-dialog__container {
    display: unset; 
}
</style>

<script>
import { EventBus } from '../../../event-bus.js'

export default {

    props:{
        integration_id: {type: String, required:true},
        payloads: {type: String, required: true}
    },

    data() {
        return {
            testLiveRateDialog: true,
            testRunning:false,
            inValidJson: false,
            parsedJson: [],
            formattedPayloads: "",
            testSuccessful: false
        }
    },

    mounted() {

        if(this.payloads != ""){            
            this.formatPayload(this.payloads);
        }
        
        this.parsePayload();
    },

    watch: {
        testLiveRateDialog(value, oldValue) {
            if (value != oldValue) {
                this.$emit('testLiveRateModalClose')
            }
        },
    },

    methods: {
        parsePayload() {
            this.parsedJson = [];
            try {
                const parsedJson = JSON.parse(this.formattedPayloads);
                
                if (Array.isArray(parsedJson) && parsedJson.every(obj => typeof obj === 'object')) {
                    this.inValidJson = false;
                    this.parsedJson = parsedJson;
                } else if (typeof parsedJson === 'object' && parsedJson !== null) {
                    this.inValidJson = false;
                    this.parsedJson.push(parsedJson);
                } else {
                    this.inValidJson = true;
                }

            } catch (error) {
                this.inValidJson = true;
            }
        },

        runTest() {
            
            this.testRunning = true;

            if (this.parsedJson.length === 0 ) this.parsePayload();

            // Use Promise.all to handle multiple requests concurrently
            Promise.all(this.parsedJson.map(this.sendRequest)).then((responses) => {
                // Update the component state with the request statuses
                this.testSuccessful = true;
            })
            .catch((error) => {
                console.error('Error:', error);
                EventBus.$emit('show-error', error);
            })
            .finally(() => {
                this.testRunning = false;
            });
        },

        sendRequest(payload, index) {
            try {
                const response = this.$http.post(`/live-rates/test/${this.integration_id}`, payload)
                return response;
            } catch (error) {
                return error.response || error;
            }
        },

        openLogsInNewTab() {
            // Using route name and params
            const routeOptions = {
                name: 'Live Rates Logs',
                query: { filter: this.integration_id },
            };

            // Generate the URL
            const url = this.$router.resolve(routeOptions).href;

            // Open the URL in a new tab
            window.open(url, '_blank');
        },

        formatPayload(payload) {
            try {
                const parsedJson = JSON.parse(payload);
                this.formattedPayloads = JSON.stringify(parsedJson, null, 2);
            } catch (error) {
                console.error('Error parsing Payload:', error.message);
                this.formattedPayloads = '';
            }
        }
    }
}
</script>